<template>
    <v-textarea
            :label="label"
            outlined
            v-model="formValues[field.nombre]"
            :placeholder="field.ayuda"
            :class="field.extra.attributes"
            :readonly="readonly"
            :rules="rules"
            :error="field.extra.attributes.includes('error_field')"
    />
</template>

<script>
    import procedureFormValidator from "@/form/procedure.form.validator";

    export default {
        name: "TextField",
        props: ['field', 'readonly', 'label', 'formValues'],

        data() {
            return {
                rules: [procedureFormValidator.input.required(this.field.validacion.required, this.readonly)],
            }
        },

        methods: {
            getLabel(){
                if (this.field.validacion.required){
                    return '* ' + this.field.etiqueta
                }

                return this.field.etiqueta
            },
        }
    };
</script>
